import { Box, BoxProps } from "@pancakeswap/uikit";
import { createWallets } from "config/wallet";
import { useActiveChainId } from "hooks/useActiveChainId";
import { useMemo } from "react";
import styled, { css, keyframes } from "styled-components";
import { useAccount } from "wagmi";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const rotateAnimation = () =>
  css`
    ${rotate} 1s linear infinite;
  `

const StyledBox = styled(Box)`
    position: relative;
    overflow: hidden;
    padding: 15px;
    margin: -15px;
`

const RotateIcon = styled.div`
    position: absolute;
    inset: -25px;
    &:before {
        position: absolute;
        content: '';
        background-image: conic-gradient(from -90deg, transparent, transparent, transparent, transparent, transparent, #fff);
        animation: ${rotateAnimation};
        inset: 0;
    }
    &:after {
        position: absolute;
        content: '';
        background: #332D3E;
        inset: 28px;
        border-radius: 30px;
    }
`

const ConnectedWallet = ({ children, ...props }: BoxProps) => {
    const { connector } = useAccount()
    const { chainId } = useActiveChainId()
    const wallets = useMemo(() => createWallets(chainId, () => {}), [chainId])
    const wallet = useMemo(() => wallets?.find(w => w.connectorId === connector?.id), [connector, wallets])
    const attrs = {
        height: 100,
        borderRadius: 32, 
        ...props
    }
    return <StyledBox {...attrs}>
        <RotateIcon />
        <img src={wallet?.icon ? String(wallet.icon) : 'https://cdn.pancakeswap.com/wallets/wallet_intro.png'} height="100%" style={{ position: 'relative', zIndex: 2 }} alt="" />
    </StyledBox>
}

export default ConnectedWallet